import { Component, OnDestroy, OnInit } from '@angular/core';
import { DropdownOption } from '@app/ui/components/dropdown/dropdown.model';
import { Subscription } from 'rxjs';
import { I18nService } from '../../services/i18n.service';

@Component({
  selector: 'rk-language-switcher',
  templateUrl: './language-switcher.component.html',
  standalone: false,
})
export class LanguageSwitcherComponent implements OnInit, OnDestroy {
  readonly options: DropdownOption[] = [
    { value: 'en-US', label: '🇬🇧 English' },
    { value: 'fr-FR', label: '🇫🇷 Français' },
    { value: 'de-DE', label: '🇩🇪 Deutsch' },
    { value: 'es-ES', label: '🇪🇸 Español' },
  ];

  selectedOption: DropdownOption = this.options[0];

  private readonly subscription = new Subscription();

  constructor(private readonly i18nService: I18nService) {}

  ngOnInit(): void {
    this.selectedOption = this.resolveOption(this.i18nService.language);
    this.subscription.add(
      this.i18nService.langSubject.subscribe(lang => {
        this.selectedOption = this.resolveOption(lang);
      }),
    );
  }

  onLanguageChange(value: string): void {
    this.i18nService.language = value;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private resolveOption(code: string): DropdownOption {
    return (
      this.options.find(o => o.value === code) ??
      this.options.find(o => o.value.startsWith(code?.split('-')[0])) ??
      this.options[0]
    );
  }
}
